module.exports = __webpack_public_path__ + "static/contract-package-2-7a3e74d8491d139043d07df9a1bf4d53.pdf";